// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Grid,
  Container,
  ClickAwayListener,
} from "@mui/material";
import moment, { calendarFormat } from "moment";
import "reactjs-popup/dist/index.css";
import useAppContextProvider from "../AppContext/useAppContextProvider.js";
import "./DemandResponseCalendar.css";
import {
  format,
  parse,
  startOfWeek,
  getDay,
  set,
  differenceInMinutes,
  parseISO,
} from "date-fns";
import PageWrapper from "../components/PageWrapper/PageWrapper.js";
import { useHistory, useLocation } from "react-router-dom";
import {
  BodyLarge,
  BodyMedium,
  BodySmall,
  H5HeadlineMedium,
  H6HeadlineSmall,
  H7TitleLarge,
  H8TitleMedium,
} from "../components/StyledComponents/Typography/Typography.tsx";
import enUS from "date-fns/locale/en-US";
import NavigateBeforeRoundedIcon from "@mui/icons-material/NavigateBeforeRounded";
import NavigateNextRoundedIcon from "@mui/icons-material/NavigateNextRounded";
import { useQuery } from "@tanstack/react-query";
import { GetUserUseQuery } from "../api/api.js";
import {
  OutlinedButton,
  PrimaryButton,
  StyledIconButton,
  SecondaryButton,
} from "../components/StyledComponents/Buttons/AuradineButtons.js";
import { LabelLarge } from "../components/StyledComponents/Typography/Typography.tsx";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import SmallCalendar from "./Components/SmallCalendar/SmallCalendar.js";
import {
  Calendar,
  Views,
  DateLocalizer,
  dateFnsLocalizer,
  momentLocalizer,
} from "react-big-calendar";
import {
  Button,
  Checkbox,
  FormControlLabel,
  Skeleton,
  Tooltip,
  Stack,
} from "@mui/material";
import { useForm } from "react-hook-form";
import {
  StyledMenu,
  StyledMenuItem,
} from "../components/StyledComponents/Menu/Menu.tsx";
import KeyboardArrowUpRoundedIcon from "@mui/icons-material/KeyboardArrowUpRounded";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { capitalizeString } from "../components/util.js";
import useDemandResponseContext from "./context/useDemandResponseContext.js";
import AddDemandResponseDialog from "./Components/AddDemandResponseDialog/AddDemandResponseDialog.js";
import AssignQSEDialog from "./Components/AssignQSEDialog/AssignQSEDialog.js";
import EventPopover from "./Components/EventPopover/EventPopover.js";
import {
  StyledFormControl,
  StyledInputLabel,
  StyledOutlinedInput,
  StyledSelect,
} from "../components/StyledComponents/Inputs/Inputs.js";
import { useAuth0 } from "@auth0/auth0-react";
import { useGetSiteLists } from "../api/queries/useGetSiteLists.ts";
import { useGetCurtailData } from "./queries/useGetCurtailData.ts";
import dayjs, { utc, timezone } from "dayjs";
import StyledLinearProgress from "../components/StyledComponents/Progress/Progress.js";
import { formatInTimeZone, toZonedTime } from "date-fns-tz";
import { isEmpty } from "lodash";
import AuradineErrorState from "../components/StyledComponents/EmptyStates/AuradineErrorState.tsx";
import * as constants from "../constants.js";
import DeleteEventDialog from "./Components/DeleteEventDialog/DeleteEventDialog.js";
import { useTheme } from "../ThemeContext/ThemeContext.js";

export const HeaderContainer = React.memo((props) => {
  const { data } = props;
  const history = useHistory();
  return (
    <Box
      className={"header-container"}
      display={"flex"}
      justifyContent="space-between"
      flexDirection="row"
      gap={4}
      marginBottom={"1.5rem"}
    >
      <Box
        className={"title-box"}
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"space-between"}
        gap={3.5}
      >
        <H7TitleLarge>
          Demand Response Configuration
        </H7TitleLarge>
        <BodyLarge>
          Manage demand response configurations by assigning
          miners to sites and QSEs, defining ramp times, and
          viewing both scheduled and manually created power
          curtailment events.
        </BodyLarge>
      </Box>
    </Box>
  );
});

const CustomCalendarHeader = (props) => {
  const { label } = props;
  const [day, date] = label?.split(" ");
  const { colors } = useTheme();
  return (
    <Box
      display={"flex"}
      className="custom-header-container"
      flexDirection={"column"}
      alignItems={"center"}
      gap={1}
      marginBottom={"2.5rem"}
    >
      <BodyLarge
        className="custom"
        sx={{ color: colors?.text?.muted }}
      >
        {day}
      </BodyLarge>
      <H5HeadlineMedium
        className="custom-header-value"
        sx={{ color: colors?.text?.muted }}
      >
        {date}
      </H5HeadlineMedium>
    </Box>
  );
};

const CustomToolbarForReactBigCalendar = (props) => {
  const history = useHistory();
  const {
    onNavigate,
    onView,
    label,
    view,
    setViewName,
    viewName,
    date,
    loading,
  } = props;
  const {
    siteSelectedName,
    siteLists,
    setSiteSelectedName,
  } = useDemandResponseContext();
  const { colors } = useTheme();
  const buttonRef = useRef(null);
  const siteButtonRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [siteMenuAnchorEl, setSiteMenuAnchorEl] =
    useState(null);
  const views = [
    { name: "day", value: "day" },
    { name: "week", value: "week" },
    { name: "month", value: "month" },
  ];

  const moveForward = () => onNavigate("NEXT");
  const moveBackward = () => onNavigate("PREV");
  const navigateToToday = () => onNavigate("TODAY");
  const handleClickAway = () => {
    setAnchorEl(null);
    setSiteMenuAnchorEl(null);
  };
  const formatDateString = (date) => {
    return view === "week" || view === "month"
      ? format(new Date(date), "MMMM yyyy")
      : format(new Date(date), "MMMM d, yyyy");
  };
  const setMenuOpen = () => {
    setAnchorEl(buttonRef.current);
  };
  const handleMenuClose = (view) => {
    onView(view);
    setViewName(view);
    setAnchorEl(null);
  };
  const handleSiteMenuClose = (siteName) => {
    setSiteMenuAnchorEl(null);
    // Handle site selection logic here
    setSiteSelectedName(siteName);
  };
  const setSiteMenuOpen = () => {
    setSiteMenuAnchorEl(siteButtonRef.current);
  };

  return (
    <Box
      display={"grid"}
      gridTemplateColumns={"1fr"}
      gap={2}
    >
      <Box
        display={"grid"}
        gridTemplateColumns={"1fr 1fr"}
        justifyContent={"space-between"}
      >
        <Box
          display={"grid"}
          gridTemplateColumns={"auto auto auto 1fr"}
          gap={2}
          className="toolbar-left-container"
          alignItems={"center"}
          justifyContent={"center"}
        >
          <OutlinedButton colors={colors} onClick={navigateToToday}>
            Today
          </OutlinedButton>

          <StyledIconButton colors={colors} onClick={moveBackward}>
            <NavigateBeforeRoundedIcon />
          </StyledIconButton>
          <StyledIconButton colors={colors} onClick={moveForward}>
            <NavigateNextRoundedIcon />
          </StyledIconButton>
          <H6HeadlineSmall sx={{ color: colors?.text?.muted }}>
            {" "}
            {formatDateString(date)}{" "}
          </H6HeadlineSmall>
        </Box>
        <Box
          display={"grid"}
          gridTemplateColumns={"auto auto auto"}
          alignItems={"center"}
          justifyContent={"end"}
          gap={2}
        >
          <SecondaryButton colors={colors}
            onClick={() => {
              history.push(
                "/jobresults?command=powercurtail&timeRange=last_2_min"
              );
              try {
                const storageToClear = [
                  "command",
                  "mode",
                  "tune",
                  "powercurtail",
                  "timeRange",
                  "status",
                  "eventType",
                  "search",
                ];
                storageToClear.forEach((key) => {
                  sessionStorage.removeItem(key);
                });
                sessionStorage.setItem(
                  "timeRange",
                  JSON.stringify("last_2_min")
                );
                sessionStorage.setItem(
                  "command",
                  JSON.stringify(["powercurtail"])
                );
              } catch (e) {
                console.error(
                  "Failed to update sessionStorage:",
                  e
                );
              }
            }}
          >
            Recent site demand jobs
          </SecondaryButton>
          <ClickAwayListener onClickAway={handleClickAway}>
            <>
              <OutlinedButton
                colors={colors}
                ref={siteButtonRef}
                onClick={setSiteMenuOpen}
                endIcon={
                  Boolean(siteMenuAnchorEl) ? (
                    <KeyboardArrowUpRoundedIcon />
                  ) : (
                    <KeyboardArrowDownRoundedIcon />
                  )
                }
              >
                {siteSelectedName !== ""
                  ? siteSelectedName
                  : "Select Site"}
              </OutlinedButton>
              <StyledMenu
                colors={colors}
                anchorEl={siteMenuAnchorEl}
                open={Boolean(siteMenuAnchorEl)}
                onClose={handleClickAway}
                sx={{
                  "& .MuiPaper-root": {
                    maxHeight: "20rem",
                    overflowY: "auto",
                  },
                }}
              >
                {siteLists &&
                  siteLists.map((siteName, index) => (
                    <StyledMenuItem
                      colors={colors}
                      value={siteSelectedName}
                      key={`menuItem${index}`}
                      selected={
                        siteName === siteSelectedName
                      }
                      onClick={(event) => {
                        event.stopPropagation();
                        handleSiteMenuClose(siteName);
                      }}
                      sx={{ minWidth: "7rem" }}
                    >
                      <BodyMedium noWrap>
                        {siteName}
                      </BodyMedium>
                    </StyledMenuItem>
                  ))}
              </StyledMenu>
            </>
          </ClickAwayListener>
          <ClickAwayListener onClickAway={handleClickAway}>
            <>
              <OutlinedButton
                colors={colors}
                ref={buttonRef}
                onClick={setMenuOpen}
                endIcon={
                  Boolean(anchorEl) ? (
                    <KeyboardArrowUpRoundedIcon />
                  ) : (
                    <KeyboardArrowDownRoundedIcon />
                  )
                }
              >
                {capitalizeString(viewName)}
              </OutlinedButton>
              <StyledMenu
                colors={colors}
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClickAway}
              >
                {views &&
                  views.map((calendarView, index) => (
                    <StyledMenuItem
                      colors={colors}
                      value={calendarView.value}
                      key={`menuItem${index}`}
                      selected={
                        calendarView.value === viewName
                      }
                      onClick={(event) => {
                        event.stopPropagation();
                        handleMenuClose(calendarView.value);
                      }}
                      sx={{ minWidth: "7rem" }}
                    >
                      {capitalizeString(calendarView.name)}
                    </StyledMenuItem>
                  ))}
              </StyledMenu>
            </>
          </ClickAwayListener>
        </Box>
      </Box>
      <Box>{loading && <StyledLinearProgress colors={colors} />}</Box>
    </Box>
  );
};

const QSEAssignmentContainer = (props) => {
  const {
    handleVoltusEventsChange,
    handleCPowerEventsChange,
    handleManualEventsChange,
    userRole,
  } = props;
  const { colors } = useTheme();
  const { setOpenQSEDialog } = useDemandResponseContext();
  const { register, watch } = useForm({
    defaultValues: {
      voltusEventsShown: true,
      cPowerEventsShown: true,
      powerCurtailOperationShown: true,
    },
  });

  // Watch the values of the checkboxes
  const voltusEventsShown = watch("voltusEventsShown");
  const cPowerEventsShown = watch("cPowerEventsShown");
  const powerCurtailOperationShown = watch(
    "powerCurtailOperationShown"
  );

  useEffect(() => {
    handleVoltusEventsChange(voltusEventsShown);
  }, [voltusEventsShown, handleVoltusEventsChange]);
  useEffect(() => {
    handleCPowerEventsChange(cPowerEventsShown);
  }, [cPowerEventsShown, handleCPowerEventsChange]);
  useEffect(() => {
    handleManualEventsChange(powerCurtailOperationShown);
  }, [
    powerCurtailOperationShown,
    handleManualEventsChange,
  ]);

  return (
    <Box
      display={"grid"}
      gridTemplateRows={"auto auto auto"}
      gap={2}
    >
      <H8TitleMedium>Calendars</H8TitleMedium>
      <Box
        display={"grid"}
        gridTemplateRows={"auto auto auto"}
        gap={2}
      >
        <FormControlLabel
          sx={{ color: colors.text.primary }}
          control={
            <Checkbox
              {...register("voltusEventsShown")}
              checked={voltusEventsShown}
              sx={{
                color: "#7857FF",
                "&.Mui-checked": {
                  color: "#7857FF",
                },
              }}
            />
          }
          label={<BodyMedium>Voltus</BodyMedium>}
        />
        <FormControlLabel
          sx={{ color: colors.text.primary }}
          control={
            <Checkbox
              {...register("cPowerEventsShown")}
              checked={cPowerEventsShown}
              sx={{
                color: "#3D9DF5",
                "&.Mui-checked": {
                  color: "#3D9DF5",
                },
              }}
            />
          }
          label={<BodyMedium>CPower</BodyMedium>}
        />
        <FormControlLabel
          sx={{ color: colors.text.primary }}
          control={
            <Checkbox
              {...register("powerCurtailOperationShown")}
              checked={powerCurtailOperationShown}
              sx={{
                color: "#2D55C9",
                "&.Mui-checked": {
                  color: "#2D55C9",
                },
              }}
            />
          }
          label={
            <BodyMedium>
              Power Curtailment Operation
            </BodyMedium>
          }
        />
      </Box>
      <Box>
        <OutlinedButton colors={colors}
          startIcon={
            <span className="material-symbols-rounded">
              list_alt_add
            </span>
          }
          onClick={() => setOpenQSEDialog(true)}
          disabled={userRole ? userRole === "user" : false}
        >
          Assign
        </OutlinedButton>
      </Box>
    </Box>
  );
};

const CustomEvent = ({ event, currentView }) => {
  const diffInMin = differenceInMinutes(
    event.end,
    event.start
  );

  const EventTooltipContent = ({ event }) => {
    if (!event) return null;

    const isNonEmptyString = (value) => typeof value === "string" && value.trim().length > 0;

    return (
      <Box sx={{ p: 1 }}>
        <Stack spacing={0.5}>
          {event.start && event.end && (
            <BodySmall sx={{ color: "white" }}>
              {format(event.start, "h:mm a")} – {format(event.end, "h:mm a")}
            </BodySmall>
          )}
          {typeof event.target_power_usage === "number" && !isNaN(event.target_power_usage) && (
            <BodySmall sx={{ color: "white" }}>
              {event.target_power_usage} {event.per_miner_target_power ? "W" : "MW"}
            </BodySmall>
          )}
          {isNonEmptyString(event.source) && (
            <BodySmall sx={{ color: "white" }}>
              Source: {capitalizeString(event.source)}
            </BodySmall>
          )}
           {isNonEmptyString(event.id) && (
            <BodySmall sx={{ color: "white" }}>
              ID: {event.id}
            </BodySmall>
          )}
          {isNonEmptyString(event.email) && (
            <BodySmall sx={{ color: "white" }}>
              Email: {event.email}
            </BodySmall>
          )}
          {isNonEmptyString(event.timezone) && (
            <BodySmall sx={{ color: "white" }}>
              Originated from Timezone: {event.timezone}
            </BodySmall>
          )}
          {isNonEmptyString(event.eventType) && (
            <BodySmall sx={{ color: "white" }}>
              Event type: {event.eventType}
            </BodySmall>
          )}
          {event.recurring != null && (
            <BodySmall sx={{ color: "white" }}>
              Recurring: {event.recurring ? "Yes" : "No"}
            </BodySmall>
          )}
        </Stack>
      </Box>
    );
  };

  return (
    <Tooltip
      title={<EventTooltipContent event={event} />}
      arrow
      placement="top"
    >
      {(currentView !== "month" && diffInMin > 45) ? (
        <div display={"flex"} justifyContent={"flex-start"}>
          <BodySmall sx={{ color: "#fff" }}>
            {`${format(event.start, "h:mm a")} - ${format(event.end, "h:mm a")}`} {" "}
            {event.eventType === "Scheduled Standby" ? "Standby" : event.eventType}
          </BodySmall>
          {(event && (event.recurring === true)) ? (
            <BodySmall sx={{ color: "#fff" }}>
              Recurring
            </BodySmall>
          ) : (
            <></>
          )}
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            flexWrap: "wrap",
          }}
        >
          <BodySmall sx={{ color: "#fff" }}>
            {`${format(event.start, "h:mm a")} - ${format(event.end, "h:mm a")} ${
              event.eventType === "Scheduled Standby" ? "Standby" : event.eventType
            } ${event && event.recurring ? "Recurring" : ""}`}
          </BodySmall>
        </div>
      )}
    </Tooltip>
  );

};

/**
 * Represents the DemandResponse page component.
 * This component displays a table of miner devices and provides functionality to interact with them.
 */
const DemandResponseConfigurationPage = () => {
  const calendarRef = useRef(null);
  console.log("Calendar ref", calendarRef);
  const eventRef = useRef(null);
  const { colors } = useTheme();

  // dayjs.extend(utc);
  // dayjs.extend(timezone);

  const {
    selectedDate,
    calendarEvents,
    openPowerCurtailOperationModal,
    setOpenPowerCurtailOperationModal,
    eventModalData,
    setEventModalData,
    setEventModalAnchor,
    siteSelectedName,
    setSiteSelectedName,
    setSiteLists,
    setUseFamilyPowerMin,
    setUseFamilyPowerMax,
    bigCalendarSelectedDate,
    setBigCalendarSelectedDate,
  } = useDemandResponseContext();
  const [voltusEventsShown, setVoltusEventsShown] =
    useState(false);
  const [cPowerEventsShown, setCPowerEventsShown] =
    useState(false);
  const [manualEventsShown, setManualEventsShown] =
    useState(false);

  const handleVoltusEventsChange = (value) => {
    setVoltusEventsShown(value);
  };
  const handleCPowerEventsChange = (value) => {
    setCPowerEventsShown(value);
  };
  const handleManualEventsChange = (value) => {
    setManualEventsShown(value);
  };

  const [viewName, setViewName] = useState("day");

  const localizer = dateFnsLocalizer({
    format,
    parse,
    startOfWeek,
    getDay,
    locales: { enUS },
  });

  const [
    currentCurtailModalOpen,
    setCurrentCurtailModalOpen,
  ] = useState(false);
  const [currentCurtail, setCurrentCurtail] =
    useState(null);

  const timeZone =
    Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Helper to check overlap
  const isOverlapping = (event, allEvents) => {
    return allEvents.some(
      (e) =>
        e.id !== event.id &&
        ((event.start < e.end && event.end > e.start) ||
          (e.start < event.end && e.end > event.start))
    );
  };

  const eventPropGetter = (event) => {
    const overlapping = isOverlapping(event, calEvents);
    let backgroundColor = event.color || "#3174ad";

    return {
      style: {
        backgroundColor,
        borderRadius: "0.25rem",
        padding: "0.5rem orem 0.9375rem 0.5rem",
        border: overlapping ? "1px solid #000" : "none",
      },
    };
  };

  const formats = {
    dayFormat: (date, culture, localizer) =>
      localizer.format(date, "EEE dd", culture),
    weekdayFormat: (date, culture, localizer) =>
      localizer.format(date, "EEE", culture),
    timeGutterFormat: (date, culture, localizer) =>
      localizer.format(date, "ha", culture), // Custom format for column headers
  };

  useEffect(() => {
    const startOfWeekForSelectedDate = startOfWeek(
      selectedDate,
      { weekStartsOn: 0 }
    );
    if (
      calendarRef &&
      calendarRef.current &&
      calendarRef.current.props
    ) {
      if (
        calendarRef.current.props.view === "week" ||
        calendarRef.current.props.view === "month"
      ) {
        calendarRef.current?.props?.onNavigate(
          startOfWeekForSelectedDate
        );
      } else {
        calendarRef.current?.props?.onNavigate(
          selectedDate
        );
      }
    }
  }, [selectedDate]);

  const handleSelectEvent = (props, event) => {
    // setEventModalData(props);

    setEventModalData(props);
    setEventModalAnchor(event.currentTarget);
  };

  const [authToken, setAuthToken] = React.useState("");

  const { getAccessTokenSilently, isAuthenticated } =
    useAuth0();

  useEffect(() => {
    const fetchToken = async () => {
      try {
        if (!isAuthenticated) {
          setAuthToken("");
          console.warn(
            "User is not authenticated. Fetching token..."
          );
          return;
        }
        const token = await getAccessTokenSilently({
          cacheMode: "cache-only",
          ignoreCache: true,
        });
        setAuthToken(token);
      } catch (error) {
        console.error(" Error fetching token:", error);
      }
    };
    fetchToken();
    const interval = setInterval(() => {
      fetchToken();
    }, 5 * 60 * 1000); // Refresh every 15 minutes

    return () => clearInterval(interval); // Cleanup on unmount
  }, [getAccessTokenSilently, isAuthenticated]);

  const {
    data: userInfo,
    isFetched: isUserInfoFetched,
    isFetching: isUserInfoFetching,
  } = useQuery({
    queryKey: ["userInfo"],
    queryFn: () => GetUserUseQuery(authToken),
    enabled: !!authToken,
  });
  const user = userInfo?.user;
  const userRole = userInfo?.user?.role;

  const {
    data: siteLists,
    isLoading: isSiteGroupDataLoading,
    isFetching: isSiteGroupDataFetching,
    isFetched: isSiteGroupDataFetched,
    isRefetching: isSiteGroupDataRefetching,
    refetch,
  } = useGetSiteLists({
    authToken,
    leftPanelOpen: true,
  });

  useEffect(() => {
    if (siteLists) {
      if (
        siteLists?.status === "ok" &&
        siteLists?.siteList?.length > 0
      ) {
        const siteList = siteLists?.siteList;
        const sites =
          siteList && siteList.map((site) => site.siteName);
        setSiteLists(sites);

        const defaultSiteName =
          user && user?.role === "superadmin"
            ? `Site ${userInfo?.user?.org_id}`
            : `${sites[0]}`;
        setSiteSelectedName(defaultSiteName);
      }
    }
  }, [siteLists, isSiteGroupDataFetched, userInfo]);

  const {
    data: curtailData,
    isLoading: isCurtailDataLoading,
    isFetching: isCurtailDataFetching,
    isFetched: isCurtailDataFetched,
    isRefetching: isCurtailDataRefetching,
    refetch: refetchCurtailData,
  } = useGetCurtailData({
    authToken,
    siteName: siteSelectedName,
  });

  let calEvents = [];
  if (curtailData) {
    if (curtailData?.status === "ok") {
      calEvents =
        curtailData &&
        curtailData?.curtailSchedule &&
        curtailData?.curtailSchedule.map((event) => ({
          ...event,
          id: event.id,
          source: event.source,
          start: toZonedTime(
            parseISO(event.start_time),
            timeZone
          ),
          end: toZonedTime(
            parseISO(event.end_time),
            timeZone
          ),

          startDay: dayjs(event.start_time).format(
            "DD/MM/YYYY"
          ),
          endDay: dayjs(event.end_time).format(
            "DD/MM/YYYY"
          ),
          color:
            event?.source === "manual"
              ? "#2D55C9"
              : event?.source.toLowerCase() === "voltus"
              ? "#7857FF"
              : event?.source.toLowerCase() === "cpower"
              ? "#3D9DF5"
              : "#3174ad",
        }));
    }
  }
  if (!voltusEventsShown) {
    calEvents =
      calEvents &&
      calEvents.filter(
        (event) => event.source.toLowerCase() !== "voltus"
      );
  }
  if (!cPowerEventsShown) {
    calEvents =
      calEvents &&
      calEvents.filter(
        (event) => event.source.toLowerCase() !== "cpower"
      );
  }
  if (!manualEventsShown) {
    calEvents =
      calEvents &&
      calEvents.filter(
        (event) => event.source.toLowerCase() !== "manual"
      );
  }

  // console.log("calEvents", calEvents);

  return (
    //@ts-nocheck
    <PageWrapper>
      <HeaderContainer />
      {
        <Box
          display={"grid"}
          gridTemplateColumns={"0.8fr 3.2fr"}
          sx={{ height: "calc(100vh - 12rem)" }}
          className="demand-response-page-container"
        >
          {!isEmpty(siteLists) &&
            siteLists?.status === "ok" &&
            Array.isArray(siteLists?.siteList) &&
            siteLists.siteList.length === 0 && (
              <>
                <Box></Box>
                <Box
                  display={"flex"}
                  flexDirection={"row"}
                  justifyContent={"flex-start"}
                  alignItems={"center"}
                  flexGrow={1}
                >
                  <AuradineErrorState
                    message={`You may not have permissions to any sites. Please contact superadmin`}
                  />
                </Box>
              </>
            )}
          {!isEmpty(siteLists) &&
            siteLists?.status !== "ok" && (
              <>
                <Box></Box>
                <Box
                  display={"flex"}
                  flexDirection={"row"}
                  justifyContent={"flex-start"}
                  alignItems={"center"}
                  flexGrow={1}
                >
                  <AuradineErrorState
                    message={`${siteLists.msg}. Please contact superadmin`}
                  />
                </Box>
              </>
            )}
          {isCurtailDataLoading &&
            !isCurtailDataFetched && (
              <>
                <Box
                  className="leftSideControlsContainer"
                  sx={{ height: "calc(100vh - 12rem)" }}
                  display="grid"
                  rowGap={6}
                  gridTemplateRows={"0.1fr 0.8fr 2fr"}
                >
                  <Skeleton
                    variant="rectangular"
                    animation="pulse"
                    width="100%"
                    height={60}
                    sx={{ mb: 2, borderRadius: 2 }}
                  />
                  <Skeleton
                    variant="rectangular"
                    animation="pulse"
                    width="100%"
                    height={200}
                    sx={{ mb: 2, borderRadius: 2 }}
                  />
                  <Skeleton
                    variant="rectangular"
                    animation="pulse"
                    width="100%"
                    height={400}
                    sx={{ borderRadius: 2 }}
                  />
                </Box>
                <Box
                  className="rightSideCalendarContainer"
                  display="grid"
                  style={{
                    //backgroundColor: colors?.background?.paper || "#F3F2FD",
                    borderRadius: "1rem",
                    paddingLeft: "1.5rem",
                  }}
                >
                  <Skeleton
                    variant="rectangular"
                    animation="pulse"
                    width="100%"
                    height="calc(100vh - 12rem)"
                    sx={{ borderRadius: 2 }}
                  />
                </Box>
              </>
            )}
          {!isEmpty(siteLists) &&
            siteLists.status === "ok" &&
            Array.isArray(siteLists.siteList) &&
            siteLists.siteList.length > 0 &&
            !isCurtailDataLoading &&
            !isCurtailDataFetching && (
              <>
                <Box
                  display={"grid"}
                  className="leftSideControlsContainer"
                  sx={{ height: "calc(100vh - 12rem)" }}
                  rowGap={6}
                  gridTemplateRows={"0.1fr 0.8fr 2fr"}
                >
                  <Box
                    display={"grid"}
                    gridTemplateColumns="repeat(3, 1fr)"
                    className="createButtonContainer"
                  >
                    <PrimaryButton colors={colors}
                      sx={{
                        gridColumn: "1/ span 1",
                        width: "7.13rem",
                      }}
                      onClick={() =>
                        setOpenPowerCurtailOperationModal(
                          true
                        )
                      }
                      disabled={
                        userRole
                          ? userRole === "user"
                          : false
                      }
                    >
                      <Box
                        display={"flex"}
                        sx={{ gap: "0.5rem" }}
                      >
                        Create
                        <AddRoundedIcon />
                      </Box>
                    </PrimaryButton>
                  </Box>
                  <Box
                    display={"grid"}
                    className="smallCalendarContainer"
                    justifyContent={"start"}
                    // gap={6}
                  >
                    <SmallCalendar />
                    <QSEAssignmentContainer
                      handleCPowerEventsChange={
                        handleCPowerEventsChange
                      }
                      handleVoltusEventsChange={
                        handleVoltusEventsChange
                      }
                      handleManualEventsChange={
                        handleManualEventsChange
                      }
                      userRole={userRole}
                    />
                  </Box>
                </Box>
                <Box
                  display={"grid"}
                  className="rightSideCalendarContainer"
                  gridTemplateRows={"fr"}
                  style={{
                    backgroundColor: colors.background.paper,
                    borderRadius: "1rem",
                    padding: "1.5rem",
                  }}
                >
                  <Calendar
                    ref={calendarRef}
                    style={{
                      height: "calc(100vh - 15rem)",
                    }}
                    defaultDate={bigCalendarSelectedDate}
                    onNavigate={(date) => {
                      setBigCalendarSelectedDate(date);
                    }}
                    //defaultView="day"
                    scrollToTime={new Date()}
                    showMultiDayTimes
                    events={calEvents}
                    // max={max}
                    localizer={localizer}
                    isLoading={isCurtailDataLoading}
                    step={60}
                    timeslots={1}
                    views={["day", "week", "month"]}
                    view={viewName}
                    onView={(view) => setViewName(view)}
                    min={new Date(1970, 1, 1, 0, 0, 0)} // Start time at 12:00 AM
                    max={new Date(1970, 1, 1, 23, 59, 59)}
                    allDayAccessor={null}
                    eventPropGetter={eventPropGetter}
                    onSelectEvent={handleSelectEvent}
                    formats={formats}
                    dayLayoutAlgorithm={"overlap"}
                    overlapOffset={50}
                    components={{
                      event: (props) => (
                        <CustomEvent
                          {...props}
                          currentView={
                            calendarRef.current?.props.view
                          }
                        />
                      ),
                      toolbar: (toolbarProps) => (
                        <CustomToolbarForReactBigCalendar
                          {...toolbarProps}
                          loading={
                            isCurtailDataLoading ||
                            isCurtailDataFetching ||
                            isCurtailDataRefetching
                          }
                          viewName={viewName}
                          setViewName={setViewName}
                        />
                      ),
                      day: {
                        header: CustomCalendarHeader,
                      },
                      week: {
                        header: CustomCalendarHeader,
                      },
                    }}
                  />
                </Box>
              </>
            )}
        </Box>
      }
      <EventPopover
        refetch={refetchCurtailData}
        userRole={userRole}
      />
      <AddDemandResponseDialog
        refetch={refetchCurtailData}
        calEvents={calEvents}
        authToken={authToken}
      />
      <AssignQSEDialog />
      <DeleteEventDialog refetch={refetchCurtailData} />
    </PageWrapper>
  );
};

export default DemandResponseConfigurationPage;
